import { render, staticRenderFns } from "./CourseText.vue?vue&type=template&id=4c8d5e7d"
import script from "./CourseText.vue?vue&type=script&lang=js"
export * from "./CourseText.vue?vue&type=script&lang=js"
import style0 from "./CourseText.vue?vue&type=style&index=0&id=4c8d5e7d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports